import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form, Field } from 'react-final-form';
import { connect } from 'react-redux';
import { Collapse, Row, Col, Button } from 'antd';
import { getRole, getIsUserSeller } from '../../reducers/userReducer';
import * as actions from '../../actions/actionCreators/accountGOSReportListActionCreator';
import { TextField, DateRangeField } from '../../atoms';
import { FormActions } from '../../components';
import { downloadFileByPostURL } from '../../utils/files';
import { links } from '../../utils/gotoLink';
import {
  accountGOSReportFilterFields,
  FORM_ACCOUNT_GOS_REPORT_FILTER,
} from '../../constants/formAccountGOSReportFilter';
import { getDateRanges } from '../../utils/dates';
import {
  formValueSelector,
  updateFormState,
} from '../../reducers/reactFinalFormReducer';
import FormStateToRedux from '../FormStateToRedux';
import RffFields from '../../atoms/rff/RffFields';

const { Panel } = Collapse;

export class AccountGOSReportFilter extends Component {
  dateFrom = '';
  dateTo = '';

  static propTypes = {
    t: PropTypes.func.isRequired,
    userRole: PropTypes.string.isRequired,
    isUserSeller: PropTypes.bool,
    initialValues: PropTypes.object,
    searchAccountGOSReport: PropTypes.func.isRequired,
    updateFormState: PropTypes.func.isRequired,
  };

  componentDidMount() {
    const { initialValues, updateFormState } = this.props;
    if (initialValues) {
      updateFormState(FORM_ACCOUNT_GOS_REPORT_FILTER, {
        values: { ...initialValues },
      });
    }
  }

  handleExportReport = () => {
    let params = {
      filter: {
        registerCode:
          this.props.initialValues?.[
            accountGOSReportFilterFields.REGISTER_CODE
          ],
        dateFrom: this.dateFrom,
        dateTo: this.dateTo,
        isSeller: this.props.isUserSeller,
      },
    };

    downloadFileByPostURL(
      links.accountGOSReportCsv,
      params,
      'account-gos-report.csv'
    );
  };

  updateFilterFields = (values) => {
    if (values) {
      this.dateFrom = values[accountGOSReportFilterFields.DATE_FROM];
      this.dateTo = values[accountGOSReportFilterFields.DATE_TO];
    }
  };

  onSubmit = (values) => {
    this.updateFilterFields(values);
    this.props.searchAccountGOSReport(values);
  };

  onClear = (form) => {
    const registerCode =
      this.props.initialValues?.[accountGOSReportFilterFields.REGISTER_CODE];
    form.restart({
      [accountGOSReportFilterFields.REGISTER_CODE]: registerCode,
    });
    this.props.updateFormState(FORM_ACCOUNT_GOS_REPORT_FILTER, { values: {} });
  };

  render() {
    const { t, initialValues } = this.props;

    return (
      <React.Fragment>
        <Collapse>
          <Panel key="filters" header={t('report.filter.panelTitle')}>
            <Form
              initialValues={initialValues}
              onSubmit={this.onSubmit}
              render={({ handleSubmit, form }) => (
                <form onSubmit={handleSubmit}>
                  <FormStateToRedux form={FORM_ACCOUNT_GOS_REPORT_FILTER} />

                  <Row gutter={24}>
                    <Col span={14}>
                      <RffFields
                        label={t('report.filter.dateRange.title')}
                        names={[
                          accountGOSReportFilterFields.DATE_FROM,
                          accountGOSReportFilterFields.DATE_TO,
                        ]}
                        placeholder={[
                          t('report.filter.dateRange.dateFromPlaceholder'),
                          t('report.filter.dateRange.dateToPlaceholder'),
                        ]}
                        component={DateRangeField}
                        allowClear={false}
                        hasFeedback={false}
                        ranges={getDateRanges(t)}
                      />
                    </Col>
                  </Row>
                  <Row gutter={12}>
                    <Col span={12}>
                      <Field
                        name={accountGOSReportFilterFields.REGISTER_CODE}
                        component={TextField}
                        hasFeedback={false}
                        type="hidden"
                      />
                    </Col>
                  </Row>
                  <FormActions>
                    <Button onClick={() => this.onClear(form)}>
                      {t('report.filter.clearBtn')}
                    </Button>
                    <Button type="primary" htmlType="submit">
                      {t('report.filter.submitBtn')}
                    </Button>
                  </FormActions>
                </form>
              )}
            />
          </Panel>
        </Collapse>
        <FormActions>
          <Button onClick={this.handleExportReport}>{t('exportCsvBtn')}</Button>
        </FormActions>
      </React.Fragment>
    );
  }
}

const selector = formValueSelector(FORM_ACCOUNT_GOS_REPORT_FILTER);

const mapStateToProps = (state) => ({
  filterValues: selector(state),
  userRole: getRole(state),
  isUserSeller: getIsUserSeller(state),
});

const mapDispatchToProps = {
  searchAccountGOSReport: actions.searchAccountGOSReport,
  updateFormState,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AccountGOSReportFilter);
